export default {
  // 通用
  common: {
    unknown: '未知',
    none: '无',
    optional: '可选',
    default: '默认',
    unlimited: '不限',
    loading: '加载中...',
    processing: '处理中...',
    searching: '搜索中...',
    cancel: '取消',
    confirm: '确认',
    ok: '确定',
    close: '关闭',
    copy: '复制',
    success: '成功',
    failed: '失败',
    error: '错误',
    submit: '提交',
    search: '搜索',
    reset: '重置',
    save: '保存',
    refresh: '刷新',
    previous: '上一页',
    next: '下一页',
    pageInfo: '第 {current} 页，共 {total} 页',
    note: '注意',
    tip: '温馨提示',
    loadingMore: '加载更多...',
    noMoreData: '没有更多数据了',
    yuan: '元'
  },

  // 品牌和标识
  brand: {
    name: '白鲸',
    logo: '白鲸 Logo',
    description: '白鲸是一个专注于保护海外华人用户隐私的数据共享平台，为用户提供安全、便捷的数据共享服务。',
    copyright: '白鲸 保留所有权利.'
  },

  // 导航
  nav: {
    home: '首页',
    receiveData: '接收数据',
    mailReceive: '邮箱接码',
    receiveRecords: '收取记录',
    faq: '常见问题',
    referralRewards: '推荐奖励',
    apiDocs: 'API文档',
    desktopDownload: '桌面端',
    ticketCenter: '工单中心',
    more: '更多',
    messageProcessing: '消息处理',
    login: '登录/注册',
    userCenter: '个人中心',
    logout: '退出登录',
    user: '用户'
  },

  // 页面标题
  titles: {
    home: '白鲸 - 保护隐私的数据共享平台',
    login: '登录/注册 - 白鲸',
    receiveCode: '接收数据 - 白鲸',
    mailReceive: '邮箱接码 - 白鲸',
    receiveRecords: '收取记录 - 白鲸',
    messageProcessing: '消息处理 - 白鲸',
    ticketCenter: '工单中心 - 白鲸',
    contact: '联系客服 - 白鲸',
    mobileApp: '移动端产品 - 白鲸',
    desktopDownload: '桌面端下载 - 白鲸',
    faq: '常见问题 - 白鲸',
    referralRewards: '推荐奖励 - 白鲸',
    apiDocs: 'API文档 - 白鲸',
    userCenter: '个人中心 - 白鲸',
    notFound: '页面未找到 - 白鲸'
  },

  // 邮箱接码
  mailReceive: {
    title: '邮箱接码',
    subtitle: '选择项目和邮箱域名，获取临时邮箱并接收验证码。',
    project: '邮箱项目',
    projectPlaceholder: '请选择项目',
    domain: '邮箱域名',
    domainPlaceholder: '请选择域名',
    price: '用户价格',
    stock: '当前库存',
    available: '个可用',
    noStock: '暂无库存',
    purchase: '获取邮箱',
    purchaseWithPrice: '按 ¥{price} 获取邮箱',
    priceTip: '收到首个验证码后按页面显示的人民币价格扣费。',
    orderTitle: '邮箱订单',
    noOrders: '暂无邮箱订单',
    emailAddress: '临时邮箱',
    verificationCode: '验证码',
    createdAt: '创建时间',
    expiresAt: '有效期至',
    expiresIn: '剩余有效期',
    copy: '复制邮箱',
    copied: '邮箱地址已复制',
    cancel: '取消订单',
    canceled: '邮箱订单已取消',
    orderCreated: '邮箱已获取，正在等待验证码',
    waitingCode: '等待验证码',
    settlementPending: '验证码已收到，供应商结算处理中',
    loading: '邮箱数据加载中…',
    emptyProjects: '暂无启用的邮箱项目',
    emptyDomains: '暂无启用的邮箱域名',
    loadFailed: '邮箱数据加载失败',
    priceFailed: '获取邮箱价格失败',
    orderFailed: '获取邮箱失败，请稍后重试',
    cancelFailed: '取消失败，请稍后重试',
    refresh: '刷新订单',
    status: {
      WAITING_CODE: '等待验证码',
      CANCELING: '正在取消',
      CODE_RECEIVED: '已收到验证码',
      CANCELED: '已取消',
      ERROR: '处理失败',
      EXPIRED: '已过期'
    }
  },

  // 首页
  home: {
    heroTitle: '保护您的隐私，安全接收共享数据',
    heroSubtitle: '白鲸为您提供临时手机号，让您在不泄露个人信息的情况下接收共享数据',
    startReceiving: '开始接收共享数据',
    learnMore: '了解更多',
    blackFriday: {
      badge: '🔥 本周黑五已开启',
      title: '随时充值，随时享受8折优惠',
      subtitle: '充值后即可参与活动，命中活动渠道自动按优惠价计费。',
      priceLabel: '活动计费',
      priceText: '全场活动8折',
      originalLabel: '原价划线展示',
      cta: '去享优惠',
      highlights: {
        auto: '活动价自动计算',
        channel: '渠道列表实时展示',
        record: '记录同步展示'
      }
    },
    whyChooseTitle: '为什么选择白鲸',
    whyChooseSubtitle: '我们提供安全、可靠的数据共享服务，保护您的隐私',
    features: {
      instant: {
        title: '即时接收',
        description: '数据实时接收，无需等待，让您的注册和登录过程更加流畅'
      },
      allTime: {
        title: '全天候服务',
        description: '7×24小时不间断服务，随时随地满足您的数据共享需求'
      },
      privacy: {
        title: '隐私保护',
        description: '使用临时临时号码，有效保护您的个人信息，防止垃圾短信和骚扰电话'
      }
    },
    howToUseTitle: '如何使用',
    howToUseSubtitle: '简单三步，轻松接收共享数据',
    steps: {
      select: {
        title: '选择临时号码',
        description: '从我们提供的临时号码列表中选择一个您需要的号码'
      },
      use: {
        title: '使用临时号码',
        description: '在需要确认身份的网站或应用中使用您选择的临时号码'
      },
      receive: {
        title: '接收共享数据',
        description: '在我们的平台上实时查看共享数据，辅助完成必要流程'
      }
    },
    platformAlt: '白鲸数据共享平台'
  },

  // 登录注册
  auth: {
    login: '登录',
    twoFactorCode: '两步验证码',
    twoFactorCodePlaceholder: '请输入身份验证器中的6位验证码',
    twoFactorPrompt: '请使用身份验证器完成登录验证。',
    register: '注册',
    welcomeBack: '欢迎回来，请登录您的账号',
    createAccount: '创建一个新账号，开始使用白鲸',
    username: '用户名',
    password: '密码',
    setPassword: '设置密码',
    confirmPassword: '确认密码',
    inviteCode: '邀请码',
    usernamePlaceholder: '请输入用户名',
    inviteCodePlaceholder: '请输入邀请码（选填）',
    passwordPlaceholder: '请输入密码',
    confirmPasswordPlaceholder: '请再次输入密码',
    agreeToTerms: '我已阅读并同意',
    userAgreement: '《用户服务协议》',
    privacyPolicy: '《隐私政策》',
    userAgreementTitle: '用户服务协议',
    privacyPolicyTitle: '隐私政策',
    agreeButton: '我已阅读并同意',
    readFullAgreement: '请阅读完整协议内容，滚动到底部后可点击同意',
    messages: {
      fillComplete: '请填写完整信息',
      passwordMismatch: '两次密码输入不一致',
      agreeRequired: '请阅读并同意用户服务协议和隐私政策',
      registerSuccess: '注册成功，请登录',
      loginSuccess: '登录成功',
      loginFailed: '登录失败:',
      registerFailed: '注册失败:',
      turnstileRequired: '请先完成人机验证',
      turnstileLoadFailed: '人机验证加载失败，请刷新后重试',
      turnstileConfigMissing: '人机验证站点密钥未配置',
      turnstileVerifyFailed: '人机验证失败，请刷新后重试',
      turnstileRetrying: '人机验证失败，正在重新验证...',
      turnstileRetryExhausted: '人机验证暂时无法完成，请切换网络、关闭VPN或更换浏览器后重试',
      turnstileDomainUnauthorized: '当前访问域名未配置人机验证，请联系客服',
      turnstileConfigError: '人机验证配置异常，请联系客服',
      platformBlocked: '平台发现有该司短信模版并且需要屏蔽，请联系平台客服。'
    },
    // 添加连接词和其他文本
    connector: {
      and: '和'
    },
    errors: {
      loginFailed: '登录失败:',
      registerFailed: '注册失败:'
    },
    userAgreementContent: {
      welcome: '欢迎您使用白鲸数据共享平台（以下简称"本平台"）提供的服务。请您在注册成为本平台用户前，仔细阅读并充分理解本协议的全部内容。当您注册、登录或使用本平台服务时，即表示您已同意并接受本协议的全部条款。',
      serviceScope: {
        title: '1. 服务范围与地域限制',
        content1: '1.1 本平台专为海外用户提供服务，不向中国大陆地区（不包括香港特别行政区、澳门特别行政区及台湾地区）的用户提供任何服务。',
        content2: '1.2 如您位于中国大陆地区或使用中国大陆IP地址访问本平台，您将无法注册、登录或使用本平台的任何功能和服务。',
        content3: '1.3 您在注册和使用本平台服务时，即声明并保证您不是中国大陆地区用户。如因您提供虚假信息导致的任何后果，您需自行承担全部责任。',
        content4: '1.4 本平台保留随时根据您的IP地址、设备信息等技术手段核查您的地理位置，并有权对中国大陆地区用户采取限制或终止服务等措施的权利。'
      },
      serviceDescription: {
        title: '2. 服务说明',
        content1: '2.1 本平台致力于为海外用户提供临时数据共享服务，帮助保护个人隐私，降低在使用各类应用和服务时的个人信息泄露风险。',
        content2: '2.2 本平台所有业务均来自第三方接入，本平台自身不提供任何自营业务。',
        content3: '2.3 本平台仅提供数据共享服务，不支持发送数据消息、接收语音共享数据或其他通讯服务。'
      },
      usageRestrictions: {
        title: '3. 使用限制',
        content1: '3.1 本平台仅限用于合法、正当的用途，包括但不限于：邮箱注册、游戏账号注册或换绑等正常应用场景。',
        content2: '3.2 本平台自动屏蔽以下高风险类型项目，包括但不限于：',
        risks: [
          '金融服务（银行、支付、贷款等）',
          '政府及公共服务',
          '交友及社交平台',
          '出行及共享服务',
          '主流电商平台（如阿里系、腾讯系等）',
          '违反平台规则的薅羊毛行为',
          '其他可能涉及高风险的项目'
        ]
      },
      disclaimer: {
        title: '4. 免责声明',
        content1: '4.1 本平台对接收的共享数据所使用的临时号码不保证是否为全新临时号码，一旦成功接收到共享数据，即视为服务完成。',
        content2: '4.2 用户应自行判断使用本服务的合法性和风险，并为自己的行为负责。如用户无视本协议使用本平台服务而造成的任何损失或法律责任，均由用户自行承担，本平台不承担任何责任。',
        content3: '4.3 本平台不对任何第三方平台的服务质量、稳定性或安全性负责。',
        content4: '4.4 如你是对应的平台在本平台发现有该司数据模板并且需要屏蔽，请联系平台客服。'
      },
      userObligations: {
        title: '5. 用户义务',
        content1: '5.1 用户承诺不利用本平台从事任何违法犯罪活动。',
        content2: '5.2 用户不得利用本平台进行诈骗、网络攻击、信息窃取等不良行为。',
        content3: '5.3 用户不得利用本平台规避实名认证、身份验证等监管要求。',
        content4: '5.4 用户承诺并保证其不是中国大陆地区用户，如违反此项声明，本平台有权立即终止服务并追究相关责任。'
      },
      accountManagement: {
        title: '6. 账号管理',
        content1: '6.1 用户应妥善保管自己的账号和密码，因账号被盗用、密码泄露等导致的损失由用户自行承担。',
        content2: '6.2 对于违反本协议或法律法规的用户，本平台有权暂停或终止其账号使用权限。',
        content3: '6.3 对于被核实为中国大陆地区的用户，本平台有权立即暂停或终止其账号，且不予退还任何费用。'
      },
      agreementModification: {
        title: '7. 协议修改',
        content1: '7.1 本平台保留随时修改本协议的权利，修改后的协议将在平台上公布。',
        content2: '7.2 如您不同意修改后的协议，应立即停止使用本平台服务；继续使用则视为您接受修改后的协议。'
      },
      legalApplication: {
        title: '8. 法律适用',
        content1: '8.1 本协议的订立、执行和解释及争议的解决均应适用您使用的当地法律。',
        content2: '8.2 如发生本协议相关的争议，双方应友好协商解决；协商不成时，任何一方均可向有管辖权的人民法院提起诉讼。'
      },
    },
    privacyPolicyContent: {
      welcome: '本隐私政策阐述了白鲸数据共享平台（以下简称"本平台"）如何收集、使用和保护您的个人信息。我们高度重视您的隐私保护，请您在使用我们的服务前仔细阅读本隐私政策。',
      informationCollection: {
        title: '1. 信息收集',
        content: '1.1 为提供服务，我们可能收集以下信息：',
        items: [
          '账号信息：用户名、密码等注册信息',
          '交易信息：充值、消费等服务使用记录',
          '设备信息：设备标识符、IP地址、浏览器类型等',
          '日志信息：您使用我们服务的操作记录'
        ]
      },
      informationUsage: {
        title: '2. 信息使用',
        content: '2.1 我们使用收集的信息用于：',
        items: [
          '提供、维护和改进我们的服务',
          '处理您的交易请求',
          '客户支持和问题解决',
          '防范欺诈和提高安全性',
          '分析服务使用情况，优化用户体验'
        ]
      },
      informationSharing: {
        title: '3. 信息共享',
        content: '3.1 除以下情况外，我们不会与任何第三方共享您的个人信息：',
        items: [
          '获得您的明确同意',
          '为完成服务必要的第三方合作伙伴（如支付处理商）',
          '遵守法律法规要求或政府执法请求',
          '保护本平台、用户或公众的权益、财产或安全'
        ]
      },
      informationSecurity: {
        title: '4. 信息安全',
        content1: '4.1 我们采取合理的安全措施保护您的个人信息，防止未经授权的访问、使用或泄露。',
        content2: '4.2 但请注意，互联网环境并非绝对安全，我们无法保证信息传输的绝对安全性。'
      },
      userRights: {
        title: '5. 用户权利',
        content: '5.1 您对自己的个人信息拥有以下权利：',
        items: [
          '访问和更正您的个人信息',
          '删除您的账号（可能导致无法继续使用我们的服务）',
          '撤回您此前授予的同意'
        ]
      },
      cookiesAndTechnology: {
        title: '6. Cookie和类似技术',
        content: '6.1 我们使用Cookie和类似技术来提供和改进服务体验，包括记住您的偏好设置、分析使用模式等。'
      },
      policyUpdate: {
        title: '7. 政策更新',
        content1: '7.1 我们可能会不时更新本隐私政策，更新后的政策将在平台上公布。',
        content2: '7.2 对于重大变更，我们可能会通过明显方式通知您。继续使用我们的服务表示您接受修订后的隐私政策。'
      },
      contactUs: {
        title: '8. 联系我们',
        content: '8.1 如您对本隐私政策有任何疑问或需要行使您的权利，请通过平台提供的客户服务渠道与我们联系。'
      },
    }
  },

  // 个人中心
  userCenter: {
    title: '个人中心',
    personalInfo: '个人信息',
    username: '用户名:',
    role: '角色:',
    securitySettings: '安全设置',
    twoFactorTitle: '两步验证（2FA）',
    twoFactorDescription: '登录时除密码外，还需要身份验证器应用生成的动态验证码。',
    twoFactorQrAlt: '两步验证绑定二维码',
    twoFactorScanOrEnter: '使用身份验证器扫描二维码，或手动输入密钥。',
    twoFactorOpenApp: '在身份验证器中打开',
    twoFactorCode: '身份验证器验证码',
    twoFactorCodePlaceholder: '6位验证码',
    twoFactorConfirm: '确认并开启',
    twoFactorDisableConfirm: '验证并关闭',
    twoFactorEnabled: '两步验证已开启',
    twoFactorDisabled: '两步验证已关闭',
    twoFactorStatusFailed: '获取两步验证状态失败',
    twoFactorSetupFailed: '两步验证绑定失败',
    twoFactorDisableFailed: '关闭两步验证失败',
    twoFactorCodeInvalid: '请输入正确的6位验证码',
    twoFactorDisableFieldsRequired: '请输入当前密码和6位验证码',
    password: '当前密码',
    passwordPlaceholder: '请输入当前密码',
    rechargeRecords: '充值记录',
    changePassword: '修改密码',
    oldPassword: '原密码',
    newPassword: '新密码',
    confirmNewPassword: '确认新密码',
    oldPasswordPlaceholder: '请输入原密码',
    newPasswordPlaceholder: '请输入新密码（至少6位）',
    confirmNewPasswordPlaceholder: '请再次输入新密码',
    confirmChange: '确认修改',
    submitting: '提交中...',
    userAvatar: '用户头像',
    validation: {
      oldPasswordRequired: '请输入原密码',
      newPasswordRequired: '请输入新密码',
      newPasswordTooShort: '新密码长度不能少于6位',
      newPasswordSameAsOld: '新密码不能与原密码相同',
      confirmPasswordRequired: '请确认新密码',
      passwordMismatch: '两次输入的密码不一致'
    },
    messages: {
      changePasswordSuccess: '密码修改成功',
      changePasswordFailed: '密码修改失败:',
      changePasswordError: '修改密码时出错:',
      parseUserInfoFailed: '解析用户信息失败:'
    }
  },

  // 充值记录
  rechargeRecords: {
    title: '充值记录',
    qrCodePay: '扫码充值',
    usdt: 'USDT充值',
    orderNo: '订单号',
    amount: '金额',
    originalAmount: '原始金额',
    feeAmount: '手续费',
    rechargeStatus: '充值状态',
    rechargeTypeName: '充值类型',
    payType: '支付方式',
    createTime: '创建时间',
    startDate: '开始日期',
    endDate: '结束日期',
    to: '至',
    loadFailed: '加载充值记录失败',
    loadError: '加载充值记录时出错',
    statuses: {
      success: '充值成功',
      pending: '待支付'
    }
  },

  // 余额
  balance: {
    title: '账户余额',
    current: '当前余额',
    recharge: '充值',
    successRate: '成功率'
  },

  // 账户相关
  account: {
    balance: '账户余额',
    successRate: '数据成功率',
    rechargeNow: '立即充值',
    balanceInsufficientTitle: '获取临时号码余额不足说明：',
    balanceInsufficientDesc: '如果你获取了临时号码，但是没有收到数据，平台是会短暂的冻结该次临时号码的费用(时长为5分钟)，计算方式为获取凭证费用+冻结费用'
  },

  // 项目操作
  project: {
    operationTitle: '项目操作',
    searchPlaceholder: '搜索项目...',
    searchButton: '项目搜索',
    searchProject: '搜索项目',
    internationalProjects: '国际项目',
    internationalProjectsButton: '查询国际项目',
    currentChannel: '当前渠道',
    project: '项目',
    channelCode: '渠道代码',
    numberSegment: '号段',
    copyAPI: '复制API',
    switch: '切换',
    channel: '渠道:',
    price: '价格:',
    connectionCode: '对接码:',
    getApiParams: '获取API参数',
    switchChannel: '切换渠道',
    noProjectsFound: '未找到相关项目',
    noProjectsHint: '如果项目不存在，可能是服务抖动，不要急着立即申请，多搜索几次看看',
    enterKeywords: '请输入关键词搜索项目',
    operationGuideTitle: '项目操作指南：',
    operationGuides: [
      '1. 在搜索框输入关键词查找项目，如"沃尔玛"、"亚马逊"等；',
      '2. 选择合适的渠道，注意价格和成功率，建议选择创建时间近的渠道；',
      '3. 高级选项可指定卡类型、特定号码或号段；',
      '4. 获取临时号码后，请在对应平台使用该号码发送验证码，系统将自动轮询验证码。'
    ],
    smsTemplateIssueTitle: '为什么发起请求后收不到数据：',
    smsTemplateIssues: [
      '1. 很大可能是短信模版不对，比如你搜的是沃尔玛，但是你的实际数据模板是"【亚马逊科技】你的共享数据为123456"，这种情况下可能无法收到共享数据，你应该搜索亚马逊科技，也就是【】里面的内容',
      '2. 如果还是收不到，你需要先使用自有方式核对一条共享数据，核对和你搜索的项目是否一致，如果有变化，请在平台提交最新的模版',
      '3. 再次强调，平台没有抖音，陌陌，支付宝，微信这类，只有一些游戏类的，保护隐私方面的项目，如不适合，请不要充值'
    ],
    newPhoneIssueTitle: '为啥我注册的号不是新号：',
    newPhoneIssue: '1. 平台无法判断号码是否是新号，需要用户自己核验，如不适合，请不要充值',
    codeReceptionTipTitle: '接码提示：',
    codeReceptionTips: [
      '1. 选择高成功率的渠道可提高接收数据成功率；',
      '2. 不同时间段接收数据成功率有差异，高峰期可能较低；',
      '3. 如长时间未接收数据，建议释放号码后重新获取；',
      '4. 部分项目可能有特定号段限制，可使用高级选项进行设置。'
    ]
  },

  // 高级选项
  advancedOptions: {
    title: '高级选项',
    collapse: '收起高级选项',
    expand: '展开高级选项',
    cardType: '卡类型',
    cardTypeOptions: {
      unlimited: '不限',
      physical: '实卡',
      virtual: '虚卡'
    },
    specificPhone: '指定号码',
    includePrefix: '指定号段',
    includePrefixPlaceholder: '可选，如：138,139',
    excludePrefix: '排除号段',
    excludePrefixPlaceholder: '可选，如：133,134',
    province: '省份',
    provincePlaceholder: '可选，如：新疆',
    getPhoneLoading: '获取中...',
    getPhoneButton: '获取号码'
  },

  // 手机号码列表
  phoneList: {
    title: '手机号码列表',
    usageTipTitle: '手机号码列表使用提示：',
    usageTips: [
      '1. 点击手机号、验证码或短信内容可快速复制；',
      '2. 状态显示剩余等待时间，超时后将不会再收到验证码；',
      '3. "释放"按钮可归还号码，不再继续接收短信；',
      '4. "拉黑"按钮可将号码加入黑名单，避免再次获取到该号码。'
    ],
    copyAllPhones: '复制所有号码',
    releaseAllPhones: '释放所有号码',
    audioToggle: '播放提示音',
    lastGetTimeTestTitle: '不来码的时候按下面要求配合我',
    lastGetTimeTestTip: '取号后记住这个最后来码时间，然后发送你业务短信验证码，观察两分钟内这个"最后来码时间"会不会更新告诉我',
    headers: {
      index: '序号',
      connectionCode: '对接码',
      location: '归属地',
      phoneNumber: '临时号码',
      verificationCode: '验证码',
      smsContent: '短信内容',
      lastGetTime: '最后来码时间',
      chargeAmount: '本次计费',
      status: '状态',
      actions: '操作'
    },
    status: {
      label: '状态',
      waiting: '等待中...',
      waitingSms: '等待共享数据...',
      received: '已接收',
      timeout: '超时'
    },
    actions: {
      release: '释放',
      blacklist: '拉黑',
      releaseAll: '释放所有',
      copyAllNumbers: '复制所有号码',
      autoSaveData: '自动保存数据',
      autoSaveDataHint: '开启后，号码首次收到验证码会自动下载数据文件。若弹出保存窗口，请在 Chrome 设置中进入“下载内容”，关闭“下载前询问每个文件的保存位置”，后续将直接保存至默认下载目录。'
    },
    audio: {
      enable: '来码提示开启',
      disable: '来码提示关闭',
      on: '来码提示开启',
      off: '来码提示关闭'
    },
    emptyState: '暂无临时号码，点击"获取号码"开始接收验证码',
    noPhones: '暂无手机号码',
    getPhone: '获取号码',
    gettingPhone: '获取中...',
    getPhoneHint: '请先选择项目和渠道，然后获取临时号码'
  },

  // 充值对话框
  recharge: {
    title: '账户充值',
    viewRecords: '充值记录',
    cardRecharge: '卡密充值',
    usdtRecharge: 'USDT充值',
    easyPayRecharge: '扫码充值',
    easypay: {
      helpTitle: '扫码充值说明',
      help1: '扫码充值是第三方平台充值，可能会有延迟几分钟到账，如果出现半小时以上未到账，请联系客服提供支付成功截图，我们将第一时间处理',
      help2: '支持支付宝和微信，但是也会有手续费5%产生，这个是支付商家收取和平台无关。',
      help3: '不会使用的或者没了解平台协议的请不要充值。'
    },
    cardNumber: '卡密号码',
    cardNumberLabel: '卡密号码',
    cardNumberPlaceholder: '请输入卡密号码',
    cardNumberRequired: '请输入卡密号码',
    recharging: '充值中...',
    rechargeButton: '充值',
    confirmRecharge: '确认充值',
    cardShop: '卡密商城',
    usdtNoticeTitle: '充值注意事项，请认真看完',
    usdtNotices: [
      '购买金币汇率会参考欧意的汇率，交易过程中请不要关闭本窗口',
      '不要使用交易所内部转账，要使用标准的链上提现转账(TRC20)，否则无法监控是否到账',
      '因为usdt是区块链上交易，如果您转错了地址或者数量（包括小数点）将无法充值成功和撤回',
      '通过usdt充值成功将赠送10%的充值金额'
    ],
    usdtProcessTitle: 'usdt充值流程',
    amount: '面额',
    amountPlaceholder: '请选择充值面额',
    amountOptions: {
      '50': '50元',
      '100': '100元',
      '200': '200元',
      '500': '500元',
      '1000': '1000元'
    },
    customAmount: '自定义金额',
    customAmountLabel: '自定义充值金额',
    customAmountPlaceholder: '请输入充值金额（100-5000）',
    amountRange: '金额范围',
    amountTooLow: '充值金额不能低于100元',
    amountTooHigh: '充值金额不能超过5000元',
    confirmAmount: '确认金额',
    transactionInfoTitle: '交易信息，当前汇率为:',
    copyPrompt: '尝试点击钱包地址或金额可直接复制👇',
    usdtWalletQrAlt: 'USDT钱包二维码',
    transactionTips: '复制钱包地址或者扫描右上方的二维码完成交易（仅支持链上交易，不支持其他内部交易），转入成功后，系统将会为您充值对应金币，如有充值问题请联系客服',
    rechargeLog: '充值日志',
    rechargeLogTitle: '充值日志',
    autoCheckMessage: '系统正在自动检测充值状态...',
    defaultRechargeLog: '等待选择充值面额...',
    tipsTitle: '重要提示',
    tips: {
      tip1: '购买时请保存好你的<strong style="color: #ef4444;">联系方式</strong>和<strong style="color: #ef4444;">订单号(不是你zfb或者wx上的订单号，是发卡生成的订单号，一般为FK或QS开头的)</strong>，如果付款完成没有卡密，可以再次查询',
      tip2: '平台的临时号码都为<strong style="color: #ef4444;">商户上传</strong>，并不知道是否是新老，一般可以通过对应app的找回密码等手段识别',
      tip3: '有很多商户会在<strong style="color: #ef4444;">多个平台</strong>上卡保证收益最大化，这样你的帐号<strong style="color: #ef4444;">可能会被盗</strong>，商户也<strong style="color: #ef4444;">随时可能换卡</strong>，请<strong style="color: #ef4444;">不要绑定重要业务</strong>',
      keywords: {
        contact: '联系方式',
        orderNumber: '订单号',
        merchantUpload: '商户上传',
        multiplePlatforms: '多个平台',
        accountStolen: '可能会被盗',
        changeCard: '随时可能换卡',
        importantBusiness: '不要绑定重要业务'
      }
    },
    // 小额充值相关
    smallAmountPlaceholder: '或自定义金额（5-300金币）',
    paymentMethod: '支付方式',
    alipay: '支付宝',
    wechatPay: '微信支付',
    pleaseSelectAmount: '请选择或输入充值金额',
    pleaseSelectPaymentMethod: '请选择支付方式',
    amountRangeError: '充值金额必须在5-300金币之间',
    creating: '创建中...',
    createOrder: '创建订单（{amount}金币）',
    orderCreatedSuccess: '订单创建成功',
    createOrderFailed: '创建订单失败',
    paymentInfo: '支付信息',
    orderNo: '订单号',
    paymentUrlTip: '请点击下方链接完成支付：',
    goToPay: '前往支付',
    scanToPayTip: '扫码支付',
    paymentQrAlt: '支付二维码',
    paymentPending: '等待支付',
    paymentSuccess: '支付成功',
    paymentSuccessMessage: '支付成功！余额已更新',
    checking: '检查中...',
    checkStatus: '检查状态',
    checkStatusFailed: '检查支付状态失败',
    // 费率相关
    originalAmount: '充值金额',
    feeAmount: '手续费',
    totalPayment: '支付金额',
    coins: '金币'
  },

  // 项目搜索对话框
  projectSearch: {
    title: '选择项目',
    searchButton: '搜索',
    channel: '渠道:',
    viewChannel: '查看渠道',
    noResults: '未找到相关项目',
    noResultsTip: '如果项目不存在，可能是服务抖动，不要急着立即申请，多搜索几次看看',
    applyProject: '申请项目',
    searchInstruction: '请输入关键词搜索项目'
  },

  // 项目申请对话框
  projectApplication: {
    title: '申请项目',
    formTip: '填写收到的数据内容。例如:"【游戏】您的验证码为123456"',
    smsContentLabel: '短信内容示例',
    smsContentPlaceholder: '请填写收到的短信内容示例',
    submitButton: '提交申请',
    contentRequired: '请输入短信内容',
    contentLengthError: '短信内容长度不能少于2个字符'
  },
  
  // 申请项目
  applyProject: {
    title: '申请项目',
    applyButton: '申请项目',
    contentExample: '填写收到的短信内容。例如:"【游戏】您的验证码为123456"',
    smsExample: '短信内容示例',
    submitButton: '提交申请'
  },

  // 渠道选择对话框
  channelSelection: {
    title: '选择渠道',
    headers: {
      channelCode: '渠道代码',
      projectId: '项目ID',
      price: '价格',
      numberSegment: '号段',
      location: '归属地',
      status: '状态',
      createTime: '创建时间',
      lastSuccess: '最后成功',
      actions: '操作'
    },
    selectChannel: '选择此渠道',
    loadingChannels: '加载渠道中...',
    noChannels: '暂无可用渠道',
    quickSwitch: '快速切换渠道',
    countryFilter: '国家筛选',
    allCountries: '全部国家',
    searchCountry: '请选择或搜索国家'
  },

  // 快速渠道切换对话框
  quickChannelSwitch: {
    title: '快速切换渠道',
    price: '价格:',
    location: '归属地:',
    numberSegment: '号段:',
    noChannelsInstruction: '暂无可用渠道，请先通过项目搜索选择渠道'
  },

  // 公告对话框
  notice: {
    title: '公告',
    autoCloseCountdown: '{count}秒后自动关闭',
    autoCloseIn: '{seconds}秒后自动关闭'
  },

  activity: {
    active: '黑五活动',
    saved: '省{amount}',
    originalPrice: '原价',
    actualPrice: '实付',
    discountAmount: '优惠'
  },

  // 收取记录页面
  receiveRecords: {
    title: '收取记录',
    subtitle: '查看您的短信接收历史记录',
    retentionNotice: '短信记录仅保留五天，如有长期保存需求，请自行导出保存',
    channelCodeFilter: '渠道代码',
    smsContentFilter: '短信内容',
    channelCodePlaceholder: '搜索渠道代码',
    smsContentPlaceholder: '搜索短信内容',
    recordsTitle: '接收记录',
    phoneTab: '号码记录',
    mailTab: '邮箱记录',
    phoneRecordsTitle: '号码记录',
    mailRecordsTitle: '邮箱记录',
    exportExcel: '导出Excel',
    exporting: '导出中...',
    headers: {
      channelCode: '渠道代码',
      amount: '金额',
      actualAmount: '实付金额',
      originalAmount: '原始金额',
      discountAmount: '优惠金额',
      activity: '活动',
      phoneNumber: '临时号码',
      verificationCode: '数据',
      smsContent: '数据内容',
      time: '时间'
    },
    copyVerificationCode: '复制共享数据',
    loadingRecords: '加载记录中...',
    noRecords: '暂无接收记录',
    noMailRecords: '暂无邮箱收码记录',
    mailHeaders: {
      project: '项目',
      email: '邮箱地址',
      verificationCode: '验证码',
      amount: '实付金额',
      status: '状态',
      receivedTime: '收码时间'
    }
  },

  // 消息处理页面
  messageProcessing: {
    title: '消息处理',
    subtitle: '查看平台发送给您的系统消息',
    feedbackButton: '问题反馈',
    messageList: '消息列表',
    unreadMessages: '未读消息',
    readMessages: '已读消息',
    systemMessage: '系统消息',
    unreadStatus: '未读',
    loadingMessages: '加载消息中...',
    noMessages: '暂无消息',
    feedbackTitle: '问题反馈',
    feedbackContent: '反馈内容',
    feedbackPlaceholder: '请描述您遇到的问题或提出建议...',
    sendFeedback: '发送反馈',
    chargingIssues: '充值问题',
    chargingGuidance: '如果是卡密商城购买，请带上购买时候的联系方式或者订单号(FK或者QS开头的，不是zfb和wx里的订单号)，如果是U充值请直接联系客服处理',
    usageIssues: '使用问题',
    usageGuidance: '请仔细阅读常见问题里的问答，能解决你99%的疑问'
  },

  // 工单中心
  ticketCenter: {
    kicker: '支持中心',
    title: '工单中心',
    subtitle: '按问题类型提交工单，在同一条时间线中持续沟通并跟踪处理进度。',
    centerSubtitle: '集中查看客服工单和平台消息，待处理内容会统一显示提醒。',
    tabsLabel: '工单中心内容',
    ticketsTab: '我的工单',
    messagesTab: '消息处理',
    create: '新建工单',
    createFirst: '创建第一张工单',
    createAnother: '新建工单',
    statusFilter: '按工单状态筛选',
    unread: '有新回复',
    emptyTitle: '暂无工单',
    emptyDescription: '遇到问题时，可以在这里提交并持续跟进。',
    selectTitle: '选择一张工单查看详情',
    selectDescription: '沟通记录、状态变化和处理结果会集中显示在这里。',
    createdAt: '创建于',
    relatedRecord: '关联记录：',
    waitUserHint: '客服正在等待你补充信息，回复后工单会自动回到处理中。',
    resolvedHint: '客服已标记问题解决。你可以确认关闭，或继续回复并重新打开。',
    timeline: '工单沟通时间线',
    loadOlderMessages: '加载更早消息',
    addReply: '补充信息',
    replyPlaceholder: '请补充有助于定位问题的信息……',
    replyPrivacyHint: '请勿发送密码、Token、API 密钥或完整支付凭证。',
    sendReply: '发送回复',
    reopenAndReply: '问题未解决，继续回复',
    ticketEnded: '这张工单已结束',
    ticketEndedHint: '如仍有问题，请新建工单并在描述中引用当前工单号。',
    cancelTicket: '取消工单',
    confirmClose: '确认关闭',
    cancelConfirm: '取消后不能继续回复，确定取消这张工单吗？',
    closeConfirm: '确认问题已解决并关闭这张工单吗？',
    cancelSuccess: '工单已取消',
    closeSuccess: '工单已关闭',
    userCancelledReason: '用户主动取消',
    createTitle: '提交新工单',
    problemType: '问题类型',
    problemTypePlaceholder: '请选择最符合的问题类型',
    relatedType: '关联记录类型',
    relatedTypeRequired: '请选择关联记录类型',
    relatedId: '关联记录编号',
    relatedIdPlaceholder: '请输入您自己的记录编号',
    relatedRecordPlaceholder: '请选择一条本人的业务记录',
    noRelatedRecords: '暂无可关联记录',
    relatedRequiredHint: '充值、钱包和提现问题必须从本人记录中选择，系统会再次校验记录归属。',
    amount: '金额',
    traceId: 'TRACE_ID',
    traceIdPlaceholder: '接口报错时可填写响应中的 TRACE_ID',
    description: '问题描述',
    descriptionPlaceholder: '请描述发生了什么、期望结果和实际结果。涉及订单时请提供订单号，不要提供密码或密钥。',
    descriptionHint: '请填写 5–1000 个字符，以便客服准确定位问题。',
    privacyNotice: '工单用于排查和沟通，不会直接执行加余额、提现审批、账号解封等核心操作。请勿提交密码、Token、API 密钥或助记词。',
    submitTicket: '提交工单',
    validationIncomplete: '请检查表单中的提示后再提交',
    validationTypeRequired: '请选择问题类型',
    validationRelatedTypeRequired: '请选择关联记录类型',
    validationRelatedIdRequired: '请选择或填写关联记录编号；不需要关联时请清除关联记录类型',
    validationRelatedIdFormat: '关联记录编号必须是正整数',
    validationContentRequired: '请填写问题描述',
    validationContentLength: '问题描述需填写 5–1000 个字符',
    createSuccess: '工单 {ticketNo} 创建成功',
    replySuccess: '回复已发送',
    filters: {
      all: '全部',
      ended: '已结束'
    },
    statuses: {
      status0: '待受理',
      status1: '处理中',
      status2: '待我补充',
      status3: '已解决',
      status4: '已关闭',
      status5: '已取消'
    },
    types: {
      type1: '取号/任务',
      type2: '号码/验证码',
      type3: '项目/专属项目',
      type4: '充值/钱包',
      type5: '开发者提现',
      type6: '账号与安全',
      type7: '开发者 API',
      type8: '功能建议',
      type9: '其他问题'
    },
    relatedTypes: {
      type1: '短信流水',
      type2: '接码任务',
      type3: '短信项目',
      type4: '普通项目申请',
      type5: '专属项目申请',
      type6: '易支付充值',
      type7: 'USDT 充值',
      type8: '卡密',
      type9: '钱包流水',
      type10: '开发者提现'
    },
    sender: {
      you: '我',
      support: '客服',
      system: '系统记录'
    }
  },

  // 移动端专用
  mobile: {
    // 头部状态栏
    header: {
      balance: '余额',
      recharge: '充值',
      receiveCode: '接收共享数据'
    },
    
    // 项目列表
    projectList: {
      title: '选择项目',
      searchPlaceholder: '搜索项目名称',
      noProjects: '暂无项目',
      projectId: '项目ID',
      available: '可用',
      viewChannels: '查看渠道',
      back: '返回',
      guide: {
        summaryTitle: '验证码没收到 / 最后来码时间更新？',
        summary: '先用自己的手机号在对应 APP 或网站接收短信，再按短信【关键词】搜索并选择完全一致的项目。',
        expand: '查看正确选项目步骤',
        collapse: '收起选项目步骤',
        stepsTitle: '请严格按照下面的步骤执行，节省的是您自己的时间',
        stepOne: '先使用自己的手机号在对应的 APP 或网站（不是在平台里指定取号）测试注册或登录一次，接收一条验证码短信。',
        stepTwo: '查看短信内容中【】括号里的关键字。',
        stepThree: '返回平台搜索对应的项目名称，再获取手机号即可正常接收短信。',
        exampleTitle: '例如：以亚马逊为例',
        exampleSms: '短信内容显示【亚马逊】您的验证码是 123456，请五分钟内完成验证。',
        exampleSearch: '在平台搜索“亚马逊”项目，可能会出现“亚马逊”“亚马逊科技”等多个项目。',
        exampleChoice: '选择的项目必须为“亚马逊”，也就是与短信【】中的关键字完全一致。',
        missingTitle: '搜不到项目应该怎么办？',
        missingContent: '复制完整的短信内容给客服，便于客服核对项目。',
        warning: '禁止申请中国的政务、银行、腾讯、阿里、滴滴等违规业务。'
      }
    },
    
    // 渠道列表
    channelList: {
      title: '选择渠道',
      titleWithCount: '选择渠道 ({count}条数据)',
      noChannels: '暂无可用渠道',
      noChannelsHint: '暂无可用渠道，请先通过项目搜索选择渠道',
      channelId: '渠道ID',
      price: '价格',
      successRate: '成功率',
      available: '可用',
      select: '选择',
      back: '返回'
    },
    
    // 充值
    recharge: {
      title: '充值',
      method: '充值方式',
      cardRecharge: '卡密充值',
      usdtRecharge: 'USDT充值',
      
      // 卡密充值
      card: {
        input: '卡密编号',
        inputPlaceholder: '请输入卡密编号',
        submit: '充值',
        submitting: '充值中...',
        success: '充值成功',
        failed: '充值失败'
      },
      
      // USDT充值
      usdt: {
        title: 'USDT充值',
        notice: '充值注意事项，请认真看完',
        noticeItems: [
          '充值方式：使用TRC20网络转账到我们的USDT地址',
          '因为usdt是区块链上交易，如果您转错了地址或者数量（包括小数点）将无法充值成功和撤回',
          '通过usdt充值成功将赠送10%的充值金额'
        ],
        amount: 'USDT金额',
        amountPlaceholder: '请选择充值金额',
        amountOptions: {
          50: '50 USDT',
          100: '100 USDT',
          200: '200 USDT',
          500: '500 USDT',
          1000: '1000 USDT'
        },
        transactionInfo: '交易信息',
        transactionInfoTitle: '交易信息',
        copyPrompt: '点击复制',
        walletAddress: '钱包地址',
        checkingStatus: '系统已开始自动检测充值状态，每5秒检测一次...',
        notDetected: '充值检查：未检测到充值到账，请确认已完成转账，系统将继续自动检测',
        detected: '充值成功：检测到{amount} USDT到账',
        log: '充值日志',
        qrCodeAlt: 'USDT钱包二维码'
      }
    },
    
    // 临时号码信息
    phoneInfo: {
      phoneNumber: '临时号码',
      message: '消息',
      verificationCode: '验证码',
      smsContent: '短信内容',
      lastGetTime: '最后来码时间',
      time: '时间',
      copySuccess: '复制成功',
      release: '释放',
      clear: '清空',
      clearAll: '清空全部'
    },
    
    // 获取临时号码
    getPhone: {
      button: '获取临时号码',
      getting: '获取中...',
      success: '获取成功',
      failed: '获取失败',
      noBalance: '余额不足',
      selectProject: '请先选择项目',
      selectChannel: '请先选择渠道'
    },
    
    // 状态
    status: {
      waiting: '等待中',
      success: '成功',
      failed: '失败',
      timeout: '超时',
      released: '已释放',
      available: '可用',
      unavailable: '不可用',
      normal: '正常',
      disabled: '禁用'
    }
  },

  // 推荐奖励页面
  referralRewards: {
    title: '推荐奖励',
    subtitle: '邀请好友使用白鲸，获取永久收益',
    rewardDescription: '奖励说明',
    rewardText: '推荐成功后，你将永久享受该用户充值金币的10%以及后续消费金币的50%反佣',
    promotionLink: '你的专属推广链接',
    copyLink: '复制链接',
    copied: '已复制 ✓',
    inviteStats: '邀请统计',
    invitedCount: '已邀请人数',
    withdrawableAmount: '可提现金额 (金币)',
    applyWithdraw: '申请提现',
    convertToCard: '转换卡密',
    inviteDetails: '邀请明细',
    inviteHeaders: {
      username: '用户名',
      registerTime: '注册时间',
      status: '状态'
    },
    statusActive: '活跃',
    statusInactive: '未激活',
    noInviteRecords: '暂无邀请记录',
    convertCardTitle: '转换卡密',
    cardType: '卡密类型',
    quantity: '数量',
    cardOptions: {
      '5': '5金币',
      '10': '10金币',
      '20': '20金币',
      '30': '30金币',
      '50': '50金币',
      '80': '80金币',
      '100': '100金币'
    },
    generateCard: '生成卡密',
    queryUnusedCards: '查询未使用卡密',
    cardList: '卡密列表',
    cardHeaders: {
      cardNumber: '卡密',
      amount: '面额 (金币)',
      createTime: '创建时间'
    },
    clickToCopy: '点击行可复制卡密'
  },

  // 提现相关
  withdraw: {
    applyTitle: '申请提现',
    recordsTitle: '提现记录',
    viewRecords: '提现记录',
    availableBalance: '可用余额',
    minAmount: '最低提现金额',
    feeRate: '手续费率',
    usdtFeeNote: '提现USDT需要按照当天欧意的汇率上浮0.3 + 3U',
    withdrawAmount: '提现金额',
    withdrawAmountPlaceholder: '请输入提现金额',
    minAmountTip: '最低提现金额为 {min} 元',
    usdtAddress: 'USDT TRC20地址',
    usdtAddressPlaceholder: '请输入USDT TRC20地址',
    usdtAddressTip: 'TRC20地址以T开头，长度为34个字符',
    remark: '备注',
    remarkPlaceholder: '选填，可备注提现用途等信息',
    fee: '手续费',
    actualAmount: '实际到账金额',
    cancel: '取消',
    submit: '提交申请',

    // 表单验证错误
    errors: {
      amountRequired: '请输入提现金额',
      amountMustBePositive: '提现金额必须大于0',
      amountExceedsBalance: '提现金额不能超过可用余额',
      amountBelowMinimum: '提现金额不能低于最低提现金额',
      addressRequired: '请输入USDT TRC20地址',
      addressInvalid: 'USDT TRC20地址格式不正确（需T开头，34位字符）'
    },

    // 状态
    status: {
      pending: '待审核',
      approved: '审核通过',
      paid: '已打款',
      completed: '已完成',
      rejected: '已驳回',
      cancelled: '已取消',
      unknown: '未知状态'
    },

    // 提现记录表头
    recordHeaders: {
      createTime: '申请时间',
      amount: '提现金额',
      fee: '手续费',
      actualAmount: '实际到账',
      usdtAddress: 'USDT地址',
      status: '状态',
      actions: '操作'
    },

    // 消息提示
    messages: {
      balanceInsufficient: '可提现余额不足',
      balanceBelowMinimum: '可提现余额不足，最低提现金额为 {min} 元',
      configLoadFailed: '获取提现配置失败，请稍后再试',
      enterAmount: '请输入提现金额',
      amountBelowMinimum: '提现金额不能低于 {min} 元',
      amountExceedsBalance: '提现金额超过可用余额',
      enterUsdtAddress: '请输入USDT TRC20地址',
      invalidUsdtAddress: 'USDT TRC20地址格式不正确，请检查',
      applySuccess: '提现申请已提交，请等待审核',
      applyFailed: '提现申请失败，请稍后再试',
      recordsFetchFailed: '获取提现记录失败',
      confirmCancelWithdraw: '确定要取消此提现申请吗？',
      userCancelled: '用户取消',
      cancelSuccess: '提现已取消',
      cancelFailed: '取消提现失败',
      noRecords: '暂无提现记录',
      detailFetchFailed: '获取提现详情失败'
    },

    // 提现详情
    detail: {
      title: '提现详情',
      viewDetail: '查看详情',
      basicInfo: '基本信息',
      timeInfo: '时间信息',
      auditInfo: '审核信息',
      withdrawId: '提现单号',
      createTime: '申请时间',
      auditTime: '审核时间',
      payTime: '打款时间',
      completeTime: '完成时间',
      auditAdmin: '审核人员',
      payAdmin: '打款人员',
      completeAdmin: '完成人员',
      adminRemark: '管理员备注',
      rejectReason: '驳回原因',
      userRemark: '用户备注',
      noRemark: '无',
      notCompleted: '未完成'
    }
  },

  // API文档页面
  apiDocs: {
    title: 'API 接口文档',
    subtitle: '通过API接入白鲸数据共享平台，为您的应用提供数据共享服务',
    noticeTitle: '注意事项',
    noticeText: '请务必花几分钟看完以下说明：',
    noticeItems: [
      'API是为了提高效率，请不要滥用，所有调用时均需加休眠1S以上',
      '如果疯狂请求将做封号处理',
      '如果接入过程中遇到问题请及时反馈，我们收到后第一时间处理',
      '获取数据建议最多获取100次，没获取到就可能真的没有了',
      '为了保证服务器能正常稳定运行，通过API一次性获取临时号码数量调整为20个',
      '如果没有获取到临时号码，务必调用拉黑接口将临时号码屏蔽的同时结束共享任务',
      '之前使用POST接入的无需修改（接口请求参数一模一样），此次加了GET方式请求，接入更简单'
    ],
    apiSections: {
      authentication: 'API认证',
      login: '登录获取token',
      getBalance: '获取用户余额',
      getPhone: '获取临时号码',
      getCode: '获取共享数据',
      mailReceive: '邮箱接码',
      blacklistPhone: '拉黑号码',
      releasePhone: '释放号码'
    },
    requestParams: '请求参数',
    requestExample: '请求示例',
    responseExample: '返回示例',
    tableHeaders: {
      param: '参数',
      required: '必选',
      type: '类型',
      description: '描述'
    },
    paramDescriptions: {
      channelId: '渠道ID，可以通过接收数据页面的获取API参数按钮获得',
      scope: '只取号段，留空为不限制（比如138）',
      scopeBlack: '排除号段，留空为不限制（比如138）'
    },
    mailApi: {
      token: 'API 登录后获取的 Token',
      serviceCode: '邮箱项目编码，可从邮箱接码页面选择的项目中获取',
      domain: '邮箱域名，例如 gmail.com',
      supplier: '邮箱供应商，默认 1（Bower）',
      codeDescription: '传入 activationId 查询本地订单状态和验证码。WAITING_CODE 表示后台仍在轮询，接口不会同步访问供应商。',
      releaseDescription: '传入 activationId 释放当前 Token 所属、尚未收码的邮箱订单。'
    },
    exampleCode: '接入示例代码',
    languageTabs: {
      python: 'Python',
      java: 'Java'
    },
    apiCredentials: {
      accessTitle: 'API访问配置',
      title: 'API认证凭证',
      description: '您可以使用API认证凭证来访问我们的API服务，请妥善保管您的凭证信息。',
      whitelistTitle: 'IP白名单',
      whitelistDescription: '仅允许保存的IP使用API凭证登录。白名单变更不会影响现有凭证。',
      credentialsDescription: '查看或生成API登录用户名和密码，与白名单独立管理。',
      securityEnabled: '安全防护已启用',
      getCredentials: '获取API凭证',
      loading: '加载中...',
      apiUsername: 'API Username',
      apiPassword: 'API Password',
      apiIpWhitelist: 'API登录IP白名单',
      apiIpWhitelistPlaceholder: '请输入允许API登录的IP，多个IP用逗号、空格或换行分隔，如：1.2.3.4, 5.6.7.8',
      apiIpWhitelistTip: '多个IP可使用逗号、空格或换行分隔，保存后立即生效。',
      apiIpWhitelistRequired: '请填写API登录IP白名单',
      addCurrentIp: '添加当前IP',
      saveWhitelist: '保存白名单',
      savingWhitelist: '保存中...',
      whitelistSaved: 'IP白名单已保存',
      whitelistSaveError: 'IP白名单保存失败',
      getCurrentIp: '获取当前IP',
      gettingCurrentIp: '获取中...',
      currentIpTitle: '当前IP',
      currentIpMessage: '当前IP',
      copyCurrentIp: '复制IP',
      currentIpEmpty: '未获取到当前IP',
      currentIpError: '获取当前IP失败，请稍后重试',
      close: '关闭',
      securityWarning: '安全提示',
      securityMessage: '请妥善保管您的API凭证，不要与他人分享。API登录仅允许白名单内IP访问，如果凭证泄露，请联系客服处理。',
      dangerTitle: '重置API凭证',
      dangerDescription: '旧凭证会立即失效，并退出当前登录。',
      resetCredentials: '重置凭证',
      resetConfirmTitle: '确认重置凭证',
      resetConfirmMessage: '重置凭证后，旧的凭证将立即失效，并且您将被强制退出登录。确定要继续吗？'
    },
    authenticationInstructions: {
      title: '关于API认证说明：',
      description: '本平台使用API Username、API Password和IP白名单进行身份认证。请分别保存白名单并获取凭证。',
      step1: '1. 在IP白名单区域添加允许登录的IP并点击"保存白名单"',
      step2: '2. 从白名单内IP使用API Username和API Password调用登录接口获取token',
      step3: '3. 使用获取到的token调用其他API接口',
      step4: '4. token永久有效，只需登录一次即可',
      step5: '5. 重置凭证后旧凭证将立即失效，需要重新登录获取新token',
      tokenNote: '关于token说明：',
      tokenMessage: '使用API凭证登录接口只需要调用一次，获取到的token永久有效。token代表了您的API身份，请妥善保管。重置API凭证后，需要使用新的API凭证重新登录获取新token。'
    }
  },

  // 联系客服页面
  contact: {
    title: '联系客服',
    redirecting: '正在跳转到客服Telegram...',
    contactNow: '立即联系客服',
    contactUsAlt: '联系我们'
  },

  // 404页面
  notFound: {
    title: '页面未找到',
    description: '抱歉，您访问的页面不存在或已被移除',
    backHome: '返回首页'
  },

  // Footer
  footer: {
    product: '产品',
    support: '支持',
    customerService: '联系客服',
    feedback: '问题反馈',
    aboutUs: '关于我们',
    mobileApp: '移动端',
    internationalProjects: '国际项目列表'
  },

  desktopDownload: {
    eyebrow: '白鲸桌面端',
    title: 'Windows 桌面客户端',
    subtitle: '在独立客户端中使用接收数据、收取记录、API 文档和工单中心，并自动获取后续版本更新。',
    platform: 'Windows x64',
    version: '当前版本 v{version}',
    download: '下载 Windows 安装包',
    fileSize: '安装包大小约 {size}',
    requirementsTitle: '系统要求',
    requirementSystem: 'Windows 10 或 Windows 11',
    requirementArch: '64 位处理器',
    requirementNetwork: '可访问白鲸服务的网络连接',
    installTitle: '安装说明',
    unsignedNotice: '如果在安装或使用过程中系统显示安全提示，请选择“仍要运行”继续使用。',
    updateNotice: '安装后客户端会自动检查新版本，下载完成后可在客户端内完成更新。',
    unavailableNotice: '暂时无法获取最新版本信息，请稍后重试。'
  },

  // 国际项目
  internationalProjects: {
    title: '国际项目列表',
    subtitle: '查看我们目前支持的所有国家和开通的项目服务',
    searchPlaceholder: '搜索国家或项目...',
    allTypes: '全部类型',
    countries: '国家',
    projects: '项目',
    totalCountries: '支持国家',
    totalProjects: '开通项目',
    filteredResults: '筛选结果',
    countriesTitle: '支持国家',
    projectsTitle: '开通项目',
    noResults: '未找到结果',
    noResultsDesc: '请尝试使用其他关键词搜索',
    projectTypes: {
      social: '社交应用',
      dating: '交友约会',
      ecommerce: '电商平台',
      entertainment: '娱乐游戏',
      tech: '科技服务',
      payment: '支付金融',
      other: '其他'
    }
  },

  // Cookie相关
  cookie: {
    consentTitle: 'Cookie 设置',
    consentDescription: '我们使用 Cookie 以允许我们网站的正常工作、个性化设计内容和广告、提供社交媒体功能并分析流量。',
    acceptAll: '接受所有 Cookie',
    rejectAll: '全部拒绝',
    cookieSettings: 'Cookie 设置',
    settingsDescription: '您可以选择启用或禁用不同类别的 Cookie。必要的 Cookie 是网站正常运行所必需的，无法禁用。',
    categories: {
      necessary: '必要 Cookie',
      analytics: '分析 Cookie',
      marketing: '营销 Cookie',
      preferences: '偏好 Cookie'
    },
    savePreferences: '保存偏好'
  },

  // 消息提示
  messages: {
    loginRequired: '请先登录',
    searchKeywordRequired: '请输入搜索关键词',
    channelInfoNotFound: '未找到渠道信息',
    channelConnectionSuccess: '渠道对接成功',
    channelConnectionFailed: '渠道对接失败',
    projectSelectionRequired: '请先选择项目',
    channelSelectionRequired: '请先选择渠道',
    selectChannelFirst: '请先选择渠道',
    channelSelected: '渠道已选择',
    selectChannelFailed: '选择渠道失败',
    searchFailed: '搜索失败',
    getChannelsFailed: '获取渠道失败',
    applySuccess: '申请成功',
    applyFailed: '申请失败',
    rechargeFailed: '充值失败',
    phoneNumberSuccess: '获取临时号码成功',
    getCodeTimeout: '获取验证码超时',
    codeReceived: '已收到验证码',
    tasksRestored: '已恢复 {count} 个进行中的任务',
    phoneReleased: '号码已释放',
    releaseSuccess: '释放成功',
    releaseFailed: '释放失败',
    blacklistSuccess: '已将号码加入黑名单',
    blacklistFailed: '拉黑号码失败',
    allPhonesReleased: '已释放所有号码',
    releaseAllSuccess: '成功释放所有号码',
    releaseAllFailed: '释放所有号码失败',
    noPhonesToRelease: '没有需要释放的号码',
    noPhonesToCopy: '没有可复制的号码',
    copySuccess: '复制成功',
    copyFailed: '复制失败',
    copyError: '复制错误',
    selectAmountFirst: '请先选择充值面额',
    rechargeSuccess: '充值成功！',
    rechargeProcessing: '充值已成功，正在为您加载最新余额...',
    usdtInfoFetchFailed: '获取USDT充值信息失败，请稍后再试',
    calcPriceFailed: '计算价格失败，请稍后再试',
    calcUsdtPriceFailed: '计算USDT充值金额失败，请稍后再试',
    invalidAmount: '请输入有效的充值金额',
    cardRechargeSuccess: '卡密充值成功',
    cardRechargeFailed: '卡密充值失败，请稍后再试',
    rechargeAmountSelected: '您选择了充值{amount}金币，需要支付{usdtAmount} USDT，充值成功后将预计获得{totalAmount}金币(包含10%赠送)',
    checkingRecharge: '正在检查充值状态...',
    autoCheckStopped: '自动检测已停止',
    loggedOut: '已退出登录',
    loginRequiredForRewards: '请先登录后再查看推荐奖励',
    walletDataFetchFailed: '获取钱包数据失败',
    inviteListFetchFailed: '获取邀请列表失败',
    withdrawNotSupported: '提现需要联系客服，客服会在24小时内处理，只支持USDT(TRC20)，并且按照当前汇率上浮0.2+2USDT的手续费',
    withdrawBalanceInsufficient: '可提现金额不足',
    withdrawAmountTooLow: '提现金额需要大于100金币，推荐使用转换卡密功能',
    selectCardTypeAndQuantity: '请选择卡密类型并输入有效的数量',
    insufficientBalance: '余额不足！生成卡密需要 {required} 金币，当前余额 {current} 金币',
    insufficientBalanceMinimum: '余额不足5金币，无法生成卡密',
    cardGeneratedSuccess: '成功生成 {count} 个卡密',
    unusedCardsFound: '共找到 {count} 个未使用卡密',
    cardCopied: '卡密已复制到剪贴板',
    feedbackRequired: '请输入反馈内容',
    duplicateFeedbackWarning: '请不要反馈相同的问题，耐心等待客服的回复哦',
    feedbackSubmitSuccess: '反馈提交成功',
    feedbackSubmitFailed: '提交反馈失败',
    generateCardKeysFailed: '生成卡密失败',
    queryUnusedCardsFailed: '查询未使用卡密失败'
  },

  // 控制台消息
  console: {
    fetchReceiveRecordsFailed: '获取接收记录失败:',
    copyFailed: '复制失败:',
    fetchWalletDataFailed: '获取钱包数据失败:',
    fetchInviteListFailed: '获取邀请列表失败:',
    generateCardKeysFailed: '生成卡密失败:',
    queryUnusedCardsFailed: '查询未使用卡密失败:',
    submitFeedbackFailed: '提交反馈失败:',
    fetchBalanceFailed: '获取余额失败:',
    fetchSuccessRateFailed: '获取成功率失败:',
    fetchRechargeListFailed: '获取充值列表失败:',
    fetchNoticesFailed: '获取公告失败:',
    fetchProjectSearchFailed: '搜索项目失败:',
    fetchChannelsFailed: '获取渠道失败:',
    selectChannelFailed: '选择渠道失败:',
    submitProjectApplicationFailed: '提交项目申请失败:',
    getPhoneFailed: '获取号码失败:',
    releasePhoneFailed: '释放号码失败:',
    blacklistPhoneFailed: '拉黑号码失败:',
    copyAllPhonesFailed: '复制所有号码失败:',
    releaseAllPhonesFailed: '释放所有号码失败:',
    cardRechargeFailed: '卡密充值失败:',
    calcUsdtPriceFailed: '计算USDT充值金额失败:',
    checkRechargeFailed: '检查充值状态失败:',
    unknownError: '未知错误',
    fetchUnreadCountFailed: '获取未读消息数量失败:',
    updateGlobalLoginStateFailed: '更新全局登录状态失败:',
    cookiePreferencesSaved: '已保存Cookie偏好设置:',
    parseUserInfoFailed: '解析用户信息失败:',
    fetchMessagesFailed: '获取消息失败:',
    markMessageReadFailed: '标记消息为已读失败:',
    parseCookiePreferencesFailed: '无法解析保存的Cookie偏好'
  },

  // FAQ页面
  faq: {
    title: '常见问题',
    questions: {
      noSms: {
        title: '为什么我收不到共享数据？',
        possibleReasons: '可能的原因：',
        reasons: [
          '确认已经在对应项目的应用/网站给获取到的临时号码发送了共享数据',
          '临时号码被项目风控，请切换临时号码或渠道再试（建议多尝试几个临时号码）',
          '临时号码已被用过，注册相关的项目可能收不到，但登录可能可以收到',
          '项目不支持虚拟临时号码，请切换实体临时号码再试',
          '价格较高的渠道通常质量更好',
          '热门应用（如抖音、米哈游等）很难找到首次资源，基本走注册流程收不到共享数据'
        ],
        note: '注意：各渠道临时号码质量不一，与平台无关，收不到数据不扣费！'
      },
      balanceIssue: {
        title: '为什么我还有余额，但是不能临时号码，提示余额不足？',
        description: '如果你获取了临时号码，但是没有收到共享数据，平台是会短暂的冻结该临时号码的费用(时长为5分钟)',
        calculation: '计算方式为：当次临时号码费用+冻结费用'
      },
      specifyPhone: {
        title: '怎么指定临时号码？',
        answer: '在项目选择区域有一个"其他非必选项(可展开)"选项，展开后可以指定临时号码。'
      },
      phoneNotFound: {
        title: '为什么找不到指定临时号码了？',
        reasons: [
          '可能是您选择的项目池子不正确',
          '如果确认池子没错，可能是池子里的卡已被替换成新卡'
        ],
        tip: '温馨提示：做好账号维护，记录账号密码以便登录，不要指望临时号码能保持很久'
      },
      phoneDuration: {
        title: '临时号码能保存多久？',
        answer: '这由上游供应商决定，平台无法确定具体时效。'
      },
      projectNotFound: {
        title: '为什么我搜不到项目？',
        reasons: [
          '高危项目我们不提供服务，搜不到就是没有该项目',
          '搜索功能为模糊搜索，可尝试使用关键词'
        ]
      },
      internationalCards: {
        title: '有国外临时号码资源吗？',
        answer: '我们有提供国际项目的临时号码，您可以在国际项目列表中查看支持的国家和项目。https://www.qc86.shop/international-projects'
      },
      sendSms: {
        title: '能发数据吗？能接语音数据吗？',
        answer: '我们的服务仅支持接收数据消息，不支持发送数据消息或接收语音数据。'
      },
      unexpectedCharge: {
        title: '为什么莫名其妙扣钱了？',
        explanations: [
          '在数据接收倒计时结束前均有可能收到共享数据，即使点击停止获取也有可能获取到',
          '如果您在这个时间段刷新了页面，后台依然会获取临时号码，毕竟您已经发送了数据',
          '需要耐心等待完整的倒计时，如果刷新了页面，请在收取记录中查找共享数据'
        ]
      },
      otherQuestions: {
        title: '有其他问题？',
        answer: '进入工单中心，按问题类型提交工单并跟踪客服回复。'
      }
    },
    backupAddress: '防迷路地址'
  },

  // 移动端页面
  mobileApp: {
    title: '移动端产品',
    redirecting: '正在跳转到移动端网站...',
    imageAlt: '移动端产品',
    visitButton: '访问移动端网站'
  },

  // 支付确认页面
  payVerify: {
    title: '支付安全提示',
    subtitle: '请仔细核对以下订单信息',
    warningHeader: {
      title: '支付安全提示',
      subtitle: '请仔细核对以下订单信息'
    },
    antiFraud: {
      title: '防诈骗提醒',
      tips: {
        official: '官方充值',
        officialDesc: '此二维码仅用于白鲸官方平台充值金币使用',
        fraud: '谨防诈骗',
        fraudDesc: '切勿通过他人发送的二维码进行转账',
        verify: '核对信息',
        verifyDesc: '如果不是你本人充值，那么你肯定是遇到骗子了，请勿继续充值',
        contact: '如有疑问',
        contactDesc: '请立即联系官方客服确认'
      }
    },
    orderInfo: {
      title: '订单信息',
      orderNo: '订单号',
      rechargeAmount: '充值金额',
      actualPayment: '实际支付',
      coins: '金币'
    },
    actions: {
      confirm: '确认信息无误，前往支付',
      redirecting: '正在跳转...',
      tip: '点击按钮后将跳转到支付页面',
      retry: '重试'
    },
    status: {
      loading: '正在加载订单信息...',
      error: '获取订单信息失败',
      missingParam: '缺少订单号参数',
      networkError: '网络请求失败,请稍后重试',
      invalidLink: '支付链接无效'
    },
    contact: {
      text: '如有疑问，请联系官方客服'
    }
  },

  // 新手引导教程
  tutorial: {
    common: {
      skip: '跳过教程',
      next: '下一步',
      prev: '上一步',
      finish: '完成教程',
      startTutorial: '开始教程',
      skipAll: '跳过所有教程',
      restart: '重新开始',
      close: '关闭'
    },

    // 数据共享教程
    receiveCode: {
      title: '数据共享教程',
      description: '让我们一起学习如何使用平台接收共享数据',

      step1: {
        title: '搜索项目',
        content: '首先，在项目输入框中输入您想要数据的项目关键字，例如"WhatsApp"、"Telegram"等，然后点击搜索按钮'
      },

      step2: {
        title: '选择项目',
        content: '在搜索结果中，会显示匹配的项目列表。浏览列表并点击选择您需要的项目'
      },

      step3: {
        title: '选择渠道',
        content: '选择项目后，会展示该项目的可用渠道列表。不同渠道的价格和质量可能不同，选择适合您的渠道并点击"加入"按钮'
      },

      step4: {
        title: '快速切换',
        content: '在首页会显示您刚刚选择的渠道。您也可以使用快速切换按钮在不同渠道之间快速切换'
      },

      step5: {
        title: '获取临时号码',
        content: '确认选择好项目和渠道后，点击"获取号码"按钮，系统会为您分配一个临时临时号码'
      },

      step6: {
        title: '查看共享数据',
        content: '获取临时号码后，在对应的应用/网站发送数据。一旦收到数据，会自动显示在"数据内容"和"共享数据"区域'
      }
    },

    // 充值教程
    recharge: {
      title: '充值教程',
      description: '了解如何为您的账户充值',

      step1: {
        title: '打开充值',
        content: '点击"充值"按钮打开充值对话框'
      },

      step2: {
        title: '选择充值方式',
        content: '我们提供三种充值方式：扫码充值、卡密充值和USDT充值。请根据您的需求选择合适的充值方式'
      },

      step3: {
        title: '选择面额',
        content: '在充值方式中选择您需要的充值面额，系统会自动创建订单。然后按照提示完成支付即可'
      }
    },

    // 教程菜单
    menu: {
      title: '新手教程',
      receiveCodeTutorial: '数据共享教程',
      rechargeTutorial: '充值教程',
      resetAll: '重置所有教程',
      resetConfirm: '确定要重置所有教程进度吗？',
      completed: '已完成',
      notStarted: '未开始'
    }
  }
}
